import * as React from 'react';
import TextField from '@mui/material/TextField';
import ComponentTable from '../../../Components/Table/Index';
import { useState, useRef, useEffect } from 'react';
import { Column } from '../../../Components/Table/Types';
import { BoxButtons, Button } from '../../../Styles/ScreenStyle';
import { HeaderComponent } from '../../../../shared/components/HeaderComponent';
import * as Icon from '@mui/icons-material/';
import * as Yup from 'yup';
import { Form, Formik, Field, useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';
import ProdutoController from '../../../../controllers/ProdutoController';
import { Tab, Box, Grid, Button as MuiButton, Typography } from '@mui/material';
import ServicoController from '../../../../controllers/ServicoController';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { InputSelect } from '../../../../shared/components/InputSelect';
import GrupoProdutoController from '../../../../controllers/GrupoProdutoController';
import { Loader } from '../../../../shared/components/Loader';
import { toast } from 'react-toastify';
import { formatarData } from '../../../../shared/utils/helpers/date';
import { InputMoney } from '../../../../shared/components/InputMoney';
import { useLocation } from 'react-router-dom';
import { SelectAutoCompleteComponent } from '../../../../shared/components/SelectAutoCompleteComponent';
import { SelectAutoCompleteOptions } from '../../../../shared/types/selectAutoComplete';


interface Row {
  BtnEditar?: JSX.Element;
  BtnExcluir?: JSX.Element;
  prod_id: number;
  prod_armazem: string;
  prod_qtd: number;
  prod_lote: string;
}

interface ItemGrupo {
  value?: any;
  label: string;
}

export default function Produto() {
  const ref = useRef<HTMLButtonElement>(null);
  const [single, setSingle] = useState<any>(null);
  const [value, setValue] = React.useState('1');
  const { id } = useParams();
  const ProdutoId = id ? parseInt(id, 10) : null;
  const [loading, setLoading] = React.useState(false);
  const location = useLocation();
  const duploClick = location.state?.duploClick || false;

  const [itemsGrupo, setItemsGrupo] = useState<ItemGrupo[]>([]);

  const opcaoComboBox = [
    { value: 'S', label: 'Sim' },
    { value: 'N', label: 'Não' },
  ];

  const opcaoComboUnidadeMedida = [
    { value: 'PC', label: 'PC' },
    { value: 'UN', label: 'UN' },
    { value: 'CX', label: 'CX' },
    { value: 'ML', label: 'ML' },
    { value: 'KG', label: 'KG' },
    { value: 'G', label: 'G' },
    { value: 'PCT', label: 'PCT' },
    { value: 'M', label: 'M' },
    { value: 'HR', label: 'HR' },
  ]

  const tableColumns: Column[] = [
    { id: 'BtnEditar', label: '', width: 60, minWidth: 0, maxWidth: undefined },
    { id: 'Id', label: 'Id', minWidth: 0, maxWidth: undefined },
    { id: 'BtnExcluir', label: '', width: 60, minWidth: 0, maxWidth: undefined },
    { id: 'Armazem', label: 'Armazem', minWidth: 0, maxWidth: undefined },
    { id: 'Lote', label: 'Lote', minWidth: 0, maxWidth: undefined },
    { id: 'Saida', label: 'Saída', minWidth: 0, maxWidth: undefined },
  ];
  const [tableRows] = useState<Row[]>([]);

  const tableColumnsKit: Column[] = [
    { id: 'BtnExcluir', label: '', width: 60, minWidth: 0, maxWidth: undefined },
    { id: 'KitCodigo', label: 'Código', minWidth: 0, maxWidth: undefined },
    { id: 'KitDescricao', label: 'Produto', minWidth: 0, maxWidth: undefined },
    { id: 'KitQuantidade', label: 'Quantidade', minWidth: 0, maxWidth: undefined },
  ];

  const TAB_1_FIELDS = ['Descricao', 'Grupo', 'UnidadeMedida', 'UltimaCompra', 'ValorVenda', 'Fabricante', 'PartNumber', 'Observacao', 'Variacao', 'Usado', 'CodigoBarras', 'Tipo', 'Comissao', 'Disponivel', 'PesoLiquido', 'PesoBruto', 'ImgPath'];
  const TAB_2_FIELDS = ['NCM', 'GrupoTributario', 'ExTIPI', 'EnquadramentoIPI', 'AliquotaIPI', 'AliquotaPIS', 'AliquotaCOFINS', 'CEST', 'CodigoANVISA', 'PrecoMaximo', 'ValorCusto', 'OrigemMercadoria', 'FCI', 'CodigoANP', 'DescricaoANP', 'ServTribMunicipal', 'ServIss', 'ServNbs', 'ServTipoOperacao', 'ServDiscriminacao'];
  const TAB_3_FIELDS = ['ControlaLote', 'Armazem', 'Saldo', 'SaldoMinimo', 'Lote'];
  const TAB_4_FIELDS = ['DescricaoKit', 'QuantidadeKit'];
  ''
  interface ObserverProps {
    setTab: (newValue: string) => void;
  }

  const FormikTabObserver = ({ setTab }: ObserverProps) => {
    const { submitCount, isValid, errors } = useFormikContext();
    // Criamos uma referência para guardar quantos cliques tinham antes
    const prevSubmitCountRef = useRef(0);

    useEffect(() => {
      // A lógica só roda se o contador ATUAL for maior que o ANTERIOR
      // Ou seja: O usuário acabou de clicar no botão
      if (submitCount > prevSubmitCountRef.current) {

        // Atualiza a referência imediatamente
        prevSubmitCountRef.current = submitCount;

        // Se tiver erros, executa a lógica do Toast e Troca de Aba
        if (!isValid) {
          const errorKeys = Object.keys(errors);

          const hasErrorTab1 = errorKeys.some(field => TAB_1_FIELDS.includes(field));
          const hasErrorTab2 = errorKeys.some(field => TAB_2_FIELDS.includes(field));
          const hasErrorTab3 = errorKeys.some(field => TAB_3_FIELDS.includes(field));
          const hasErrorTab4 = errorKeys.some(field => TAB_4_FIELDS.includes(field));

          // Usamos toastId para evitar duplicidade se o React renderizar 2x rápido
          if (hasErrorTab1) {
            setTab('1');
            toast.warning("Verifique os campos obrigatórios na aba Dados Gerais", { toastId: 'erro-tab-1' });
          } else if (hasErrorTab2) {
            setTab('2');
            toast.warning("Verifique os campos obrigatórios na aba Dados Fiscais", { toastId: 'erro-tab-2' });
          } else if (hasErrorTab3) {
            setTab('3');
            toast.warning("Verifique os campos obrigatórios na aba Estoque", { toastId: 'erro-tab-3' });
          } else if (hasErrorTab4) {
            setTab('4');
            toast.warning("Verifique os campos obrigatórios na aba Kits", { toastId: 'erro-tab-4' });
          } else {
            // Caso genérico (erro não mapeado nas listas acima)
            toast.warning("Existem campos obrigatórios não preenchidos!", { toastId: 'erro-generico' });
          }
        }
      }
    }, [submitCount, isValid, errors, setTab]);

    return null;
  };


  useEffect(() => {
    ref?.current?.click();
    const initialValues = {};
    getGrupo(initialValues);
  }, []);

  useEffect(() => {
    if (ProdutoId !== null && ProdutoId !== undefined) {
      getSingle(ProdutoId);
    }
  }, [ProdutoId]);


  const getSingle = async (ProdutoId: number) => {
    setLoading(true);
    const Response = await ProdutoController.ListarUnico(ProdutoId);
    const data = Response.Data;

    // Os autocompletes de Serviço-Tributos exibem a descrição, mas a proc só
    // retorna o código. Buscamos a descrição de cada código para exibir na edição.
    if (data) {
      const [issList, nbsList, oprList] = await Promise.all([
        data.prod_SERV_iss ? ServicoController.listarISS({ Codigo: String(data.prod_SERV_iss) }) : Promise.resolve([]),
        data.prod_SERV_nbs ? ServicoController.listarNBS({ Codigo: String(data.prod_SERV_nbs) }) : Promise.resolve([]),
        data.prod_SERV_tipoOperacao ? ServicoController.listarOperacao({ Codigo: String(data.prod_SERV_tipoOperacao) }) : Promise.resolve([]),
      ]);

      const issMatch = (issList || []).find((i: any) => String(i[SERV_COLS.iss.code]) === String(data.prod_SERV_iss));
      const nbsMatch = (nbsList || []).find((i: any) => String(i[SERV_COLS.nbs.code]) === String(data.prod_SERV_nbs));
      const oprMatch = (oprList || []).find((i: any) => String(i[SERV_COLS.opr.code]) === String(data.prod_SERV_tipoOperacao));

      data.prod_SERV_issDescricao = issMatch?.[SERV_COLS.iss.completa] ?? '';
      data.prod_SERV_nbsDescricao = nbsMatch?.[SERV_COLS.nbs.completa] ?? '';
      data.prod_SERV_tipoOperacaoDescricao = oprMatch?.[SERV_COLS.opr.completa] ?? '';
    }

    setLoading(false);
    setSingle(data);
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const getGrupo = async (values: any): Promise<void> => {
    const DataRows: any = [];
    setLoading(true);
    const Response = await GrupoProdutoController.Listar(values);
    setLoading(false);

    if (Response.StatusCode === 200 && Response?.Data?.length > 0) {
      Response.Data.map((item: any) => {
        DataRows.push({
          value: item.grp_id,
          label: item.grp_siglaid,
        });

        setItemsGrupo(DataRows);
      });
    }
  };

  const handleSubmit = async (
    values: any,
    { setSubmitting, resetForm }: any
  ): Promise<void> => {

    if (ProdutoId === null) {
      setLoading(true);

      const response = await ProdutoController.Adicionar(values);
      setLoading(false);

      if (response.StatusCode === 200) {
        toast('Produto incluido com sucesso!', {
          type: 'success',
        });
        history.back();
      } else {
        toast('Erro ao incluir o produto!', {
          type: 'error',
        });
        resetForm();
      }
    } else {
      await editarProduto(values, { setSubmitting, resetForm });
    }

    setSubmitting(false);
  };

  const editarProduto = async (
    values: any,
    { setSubmitting }: any
  ) => {
    const request = {
      ProdutoId: ProdutoId,
      ...values,
    };

    setLoading(true);
    const response = await ProdutoController.Atualizar(request);
    setLoading(false);

    if (response.StatusCode === 204) {
      toast('Produto atualizado com sucesso!', {
        type: 'success',
      });
      history.back();
    } else {
      toast('Erro ao atualizar o produto!', {
        type: 'error',
      });
    }
    setSubmitting(false);
  };

  const initialValues = {
    ProdutoIdPromatec: single?.prodID_promatec || null,
    ImgPath: single?.prod_img_path || '',
    ImgName: single?.prod_img_name || '',
    Descricao: single?.prod_descricao || '',
    Disponivel: single?.prod_disponivel || '',
    Variacao: single?.prod_variacao || '',
    Usado: single?.prod_usado || '',
    CodigoBarras: single?.prod_codigo_barras || '',
    Tipo: single?.prod_tipo || '',
    Comissao: single?.prod_comissao || null,
    Grupo: single?.prod_grupo || '',
    Departamento: single?.prod_departamento || '',
    UnidadeMedida: single?.prod_unidade_medida || '',
    PesoLiquido: single?.prod_peso_liquido || null,
    PesoBruto: single?.prod_peso_bruto || null,
    UltimaCompra: formatarData(new Date()),
    ValorVenda: single?.prod_valor_venda || null,
    Fabricante: single?.prod_fabricante || '',
    PartNumber: single?.prod_partNumber || '',
    Observacao: single?.prod_observacao || '',

    GrupoTributario: single?.prod_grupo_tributario || '',
    ExTIPI: single?.prod_extipi || '',
    EnquadramentoIPI: single?.prod_enquadramento_ipi || '',
    AliquotaIPI: single?.prod_aliquota_ipi || null,
    AliquotaPIS: single?.prod_aliquota_pis || null,
    AliquotaCOFINS: single?.prod_aliquota_cofins || null,
    NCM: single?.prod_ncm || '',
    CEST: single?.prod_cest || '',
    // A coluna e prod_codigo_anvisa. Lia-se prod_cod_anvisa, que nao existe: o campo
    // gravava certo e voltava SEMPRE vazio ao abrir o produto.
    CodigoANVISA: single?.prod_codigo_anvisa || '',
    PrecoMaximo: single?.prod_preco_maximo || null,
    ValorCusto: single?.prod_valorCusto || null,
    OrigemMercadoria: single?.prod_origem_mercadoria || '',
    FCI: single?.prod_fci || '',
    CodigoANP: single?.prod_codigo_anp || '',
    DescricaoANP: single?.prod_descricao_anp || '',

    ControlaLote: single?.prod_controla_lote || '',
    Armazem: single?.prod_armazem || '',
    // As colunas sao prod_qtd e prod_qtd_minima. Lia-se prod_saldo/prod_saldo_minimo,
    // que nao existem na tabela - o nome 'saldo' so aparece nos PARAMETROS da procedure
    // (@p_prod_saldo), e foi dai que a confusao veio.
    Saldo: single?.prod_qtd ?? null,
    SaldoMinimo: single?.prod_qtd_minima ?? null,
    Lote: single?.prod_lote || '',

    ProdutoKit: single?.prod_produto_kit || '',
    QuantidadeKit: single?.prod_quantidade_kit || null,

    // ===== Serviço - Tributos =====
    ServTribMunicipal:          single?.prod_SERV_tribMunicipal          || '',
    ServIssEspecifico:          single?.prod_SERV_IssEspecifico          || '',
    ServCodigoFiscalPrestacao:  single?.prod_SERV_codigoFiscalPrestacao  || '',
    ServIss:                    single?.prod_SERV_iss                    ?? null,
    ServIssDescricao:           single?.prod_SERV_issDescricao           || '',
    ServNbs:                    single?.prod_SERV_nbs                    ?? null,
    ServNbsDescricao:           single?.prod_SERV_nbsDescricao           || '',
    ServTipoOperacao:           single?.prod_SERV_tipoOperacao           ?? null,
    ServTipoOperacaoDescricao:  single?.prod_SERV_tipoOperacaoDescricao  || '',
    ServDiscriminacao:          single?.prod_SERV_discriminacao          || '',

    Kit: (() => {
      if (!single?.Kit) return [];

      const parsedKit = typeof single.Kit === 'string'
        ? JSON.parse(single.Kit)
        : single.Kit;

      return parsedKit.map((item: any) => ({
        kit_produto: item.kit_produto || '',
        kit_descricao: item.kit_descricao || '',
        kit_quantidade: item.kit_quantidade || 0,
      }))
    })()
  };

  // NCM e CEST sao codigos fiscais puramente numericos: descarta qualquer caractere
  // que nao seja digito (tambem cobre texto colado com pontos/letras).
  const somenteDigitos = (valor: any): string => String(valor ?? '').replace(/\D/g, '');

  // Verifica se o Grupo selecionado é de Serviço (SER) ou Locação (LOC).
  // O campo Grupo guarda o grp_id (value); a sigla fica no label (grp_siglaid).
  const isServicoOuLocacao = (grupoValue: any): boolean => {
    const grupo = itemsGrupo.find((g) => String(g.value) === String(grupoValue));
    const sigla = (grupo?.label || '').toString().trim().toUpperCase();
    return sigla === 'SER' || sigla === 'LOC';
  };

  // Torna o campo obrigatório apenas quando o Grupo for SER ou LOC.
  const requiredWhenServico = (schema: Yup.StringSchema) =>
    schema.when('Grupo', {
      is: (grupo: any) => isServicoOuLocacao(grupo),
      then: (s) => s.required('Campo Obrigatório!'),
      otherwise: (s) => s.notRequired(),
    });

  const validationSchema = Yup.object().shape({
    Descricao: Yup.string()
      .required('Campo Obrigatório!')
      .min(4, 'O Campo deve ter no minimo 4 caracteres'),
    Grupo: Yup.string().required('Campo Obrigatório!'),
    //UnidadeMedida: Yup.string().required('Campo Obrigatório!'),
    UltimaCompra: Yup.string().required('Campo Obrigatório!'),
    ValorVenda: Yup.string().required('Campo Obrigatório!'),
    // NCM: obrigatório apenas quando NÃO for Serviço/Locação (inversamente proporcional)
    //
    // O tamanho é checado aqui porque a cadeia da nota fiscal grava o NCM em
    // char(8): NCM com mais de 8 dígitos estoura como "String or binary data
    // would be truncated" no meio da emissão, e com menos de 8 a validação de
    // emissão recusa a nota. Nos dois casos o usuário só descobre depois, na
    // tela do pedido, sem saber qual produto está errado.
    //
    // Quando é Serviço/Locação o campo é opcional, mas se estiver preenchido
    // vale a mesma regra - daí o test em vez de .length(), que reprovaria vazio.
    NCM: Yup.string().when('Grupo', {
      is: (grupo: any) => !isServicoOuLocacao(grupo),
      then: (s) => s.required('Campo Obrigatório!').length(8, 'O NCM tem 8 dígitos'),
      otherwise: (s) =>
        s.notRequired().test('ncm-8-digitos', 'O NCM tem 8 dígitos', (valor) => !valor || valor.length === 8),
    }),
    // Serviço - Tributos: obrigatórios apenas quando o Grupo for SER ou LOC
    ServTribMunicipal: requiredWhenServico(Yup.string()),
    ServIss: requiredWhenServico(Yup.string()),
    ServNbs: requiredWhenServico(Yup.string()),
    ServTipoOperacao: requiredWhenServico(Yup.string()),
    ServDiscriminacao: requiredWhenServico(Yup.string()),
  });

  React.useEffect(() => {
    setActiveProdutoSelected(single?.prod_produto_kit);
  }, [single]);

  const [allProdutoList, setAllProdutoList] = useState<any[]>([]);
  const [activeProdutoSelected, setActiveProdutoSelected] = useState<any>({});
  const [produtoOptions, setProdutoOptions] = useState<
    SelectAutoCompleteOptions[]
  >([]);

  const handleSearchProduto = async (value: string, type: string) => {
    if (!value && !type) return;

    const produtos = await ProdutoController.Listar({
      Descricao: value,
      ProdutoId_Promatec: '',
      CodigoBarras: '',
      Grupo: '',
      PartNumber: ''
    });
    if (produtos?.Data?.length) {
      setAllProdutoList(produtos.Data);
      setProdutoOptions(
        (produtos?.Data || [])?.map((item: any) => {
          return {
            label: item.prod_descricao,
            value: item.prod_id,
          };
        })
      );
    }
  };

  const handleAutoCompleteSelectedProduto = (
    value: SelectAutoCompleteOptions
  ) => {
    if (!value) return;

    const produtos = allProdutoList.find((item: any) => {
      return item.prod_id === value.value;
    });
    setActiveProdutoSelected(produtos);
  };

  // ===== Serviço - Tributos (Autocomplete) =====
  // Colunas retornadas pelas procedures PROC_SERVICO_*:
  //   *_id (PK) | *_code (código fiscal) | *_descricao | descricaoCompleta (label pronto)
  const SERV_COLS = {
    iss: { id: 'iss_id', code: 'iss_code', completa: 'descricaoCompleta' },
    nbs: { id: 'nbs_id', code: 'nbs_code', completa: 'descricaoCompleta' },
    opr: { id: 'opr_id', code: 'opr_code', completa: 'descricaoCompleta' },
  };

  const [issOptions, setIssOptions] = useState<SelectAutoCompleteOptions[]>([]);
  const [nbsOptions, setNbsOptions] = useState<SelectAutoCompleteOptions[]>([]);
  const [operacaoOptions, setOperacaoOptions] = useState<SelectAutoCompleteOptions[]>([]);

  const [allIssList, setAllIssList] = useState<any[]>([]);
  const [allNbsList, setAllNbsList] = useState<any[]>([]);
  const [allOperacaoList, setAllOperacaoList] = useState<any[]>([]);

  // ISS Tabela Padrão -> [dbo].[PROC_SERVICO_ISS_LISTAR]
  const handleSearchIss = async (value: string) => {
    if (!value) return;
    const codigos = await ServicoController.listarISS({ Codigo: value, Descricao: value });
    if (codigos?.length) {
      setAllIssList(codigos);
      setIssOptions(
        codigos.map((item: any) => ({
          label: item[SERV_COLS.iss.completa],
          value: item[SERV_COLS.iss.id],
        }))
      );
    }
  };

  const handleSelectIss = (
    value: SelectAutoCompleteOptions,
    setFieldValue: (field: string, value: any) => void
  ) => {
    if (!value) return;
    const iss = allIssList.find((item: any) => item[SERV_COLS.iss.id] === value.value);
    setFieldValue('ServIss', iss?.[SERV_COLS.iss.code] ?? '');
    setFieldValue('ServIssDescricao', iss?.[SERV_COLS.iss.completa] ?? '');
  };

  // NBS -> [dbo].[PROC_SERVICO_NBS_LISTAR]
  const handleSearchNbs = async (value: string) => {
    if (!value) return;
    const codigos = await ServicoController.listarNBS({ Codigo: value, Descricao: value });
    if (codigos?.length) {
      setAllNbsList(codigos);
      setNbsOptions(
        codigos.map((item: any) => ({
          label: item[SERV_COLS.nbs.completa],
          value: item[SERV_COLS.nbs.id],
        }))
      );
    }
  };

  const handleSelectNbs = (
    value: SelectAutoCompleteOptions,
    setFieldValue: (field: string, value: any) => void
  ) => {
    if (!value) return;
    const nbs = allNbsList.find((item: any) => item[SERV_COLS.nbs.id] === value.value);
    setFieldValue('ServNbs', nbs?.[SERV_COLS.nbs.code] ?? '');
    setFieldValue('ServNbsDescricao', nbs?.[SERV_COLS.nbs.completa] ?? '');
  };

  // Tipo de Operação -> [dbo].[PROC_SERVICO_OPR_LISTAR]
  const handleSearchOperacao = async (value: string) => {
    if (!value) return;
    const codigos = await ServicoController.listarOperacao({ Codigo: value, Descricao: value });
    if (codigos?.length) {
      setAllOperacaoList(codigos);
      setOperacaoOptions(
        codigos.map((item: any) => ({
          label: item[SERV_COLS.opr.completa],
          value: item[SERV_COLS.opr.id],
        }))
      );
    }
  };

  const handleSelectOperacao = (
    value: SelectAutoCompleteOptions,
    setFieldValue: (field: string, value: any) => void
  ) => {
    if (!value) return;
    const opr = allOperacaoList.find((item: any) => item[SERV_COLS.opr.id] === value.value);
    setFieldValue('ServTipoOperacao', opr?.[SERV_COLS.opr.code] ?? '');
    setFieldValue('ServTipoOperacaoDescricao', opr?.[SERV_COLS.opr.completa] ?? '');
  };

  const handleKitSubmit = (values: any, setFieldValue: (field: string, value: any) => void) => {
    if (!activeProdutoSelected?.prod_id || !values.QuantidadeKit) {
      toast.warning("Selecione um produto e informe a quantidade.");
      return;
    }

    const newKitItem = {
      kit_produto: activeProdutoSelected.prod_id,
      kit_descricao: activeProdutoSelected.prod_descricao,
      kit_quantidade: values.QuantidadeKit,
    };

    // Verifica se o produto já foi adicionado ao kit
    if (values.Kit.map((item: any) => item.kit_produto).find((prod: any) => prod == newKitItem.kit_produto)) {
      toast.warning("Produto já adicionado ao kit.");
      return;
    }

    // Atualiza o Formik garantindo que Kit é um array
    const updatedKit = [...(values.Kit || []), newKitItem];
    setFieldValue('Kit', updatedKit);

    // Limpa os campos
    //setFieldValue('QuantidadeKit', '');
    //setActiveProdutoSelected(null);
  };

  const handleRemoveKitItem = (index: number, values: any, setFieldValue: (field: string, value: any) => void) => {
    const updatedKit = values.Kit.filter((_: any, i: number) => i !== index);
    setFieldValue('Kit', updatedKit);
  };


  return (
    <Loader loading={loading}>

      <div style={{ paddingBottom: 30 }} id=''>
        <HeaderComponent text={'PRODUTOS'} className={'mb-5'} />

        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleSubmit,
            setFieldValue,
            touched,
            values,
            handleChange,
          }) => {

            // Grupo SER/LOC -> campos de Serviço obrigatórios; NCM opcional (e vice-versa)
            const isServ = isServicoOuLocacao(values.Grupo);

            // 👇 ADICIONE tableRowsKit AQUI DENTRO
            const tableRowsKit = (values.Kit || []).map((item: any, index: number) => ({
              BtnExcluir: (
                <Button onClick={() => handleRemoveKitItem(index, values, setFieldValue)} color="error">
                  <Icon.Delete />
                </Button>
              ),
              KitCodigo: item.kit_produto,
              KitDescricao: item.kit_descricao,
              KitQuantidade: item.kit_quantidade,
            }));

            return (
              <Form>
                <FormikTabObserver setTab={setValue} />
                <BoxButtons>
                  <Button
                    variant='contained'
                    onClick={() => history.back()}
                    color='warning'
                    startIcon={<Icon.ArrowBack />}
                  >
                    Voltar
                  </Button>
                  <Button
                    //type='submit'
                    variant='contained'
                    onClick={() => handleSubmit()}
                    color='success'
                    startIcon={<Icon.Save />}
                    disabled={duploClick}
                  >
                    Salvar
                  </Button>
                </BoxButtons>
                <Box sx={{ width: '100%', typography: 'body1' }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList
                        onChange={handleTabChange}
                        aria-label='lab API tabs example'
                      >
                        <Tab
                          icon={<Icon.Public />}
                          label='DADOS GERAIS'
                          value='1'
                        />
                        <Tab
                          icon={<Icon.AttachMoneyTwoTone />}
                          label='DADOS FISCAIS'
                          value='2'
                        />
                        <Tab
                          icon={<Icon.OtherHouses />}
                          label='ESTOQUE'
                          value='3'
                        />
                        <Tab
                          icon={<Icon.AddBox />}
                          label='ADICIONAR KIT'
                          value='4'
                        />
                      </TabList>
                    </Box>
                    <fieldset disabled={duploClick}>
                      <TabPanel value='1'>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Field
                              size='small'
                              //required
                              //error
                              fullWidth
                              name='ProdutoIdPromatec'
                              as={TextField}
                              id='outlined-password-input'
                              placeholder='Código do Produto'
                              type='text'
                              autoComplete='current-password'
                              //InputProps={{ readOnly: true }}
                              disabled
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Field
                              size='small'
                              fullWidth
                              multiline
                              name='Descricao'
                              as={TextField}
                              label='Descrição'
                              type='text'
                              rows={1}
                              inputProps={{ maxLength: 70 }}
                              error={
                                touched.Descricao && errors.Descricao
                                  ? errors.Descricao
                                  : ''
                              }
                              helperText={
                                touched.Descricao && errors.Descricao
                                  ? errors.Descricao
                                  : `${values.Descricao.length}/70`
                              }
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <MuiButton
                              component="label"
                              variant="contained"
                              size="large"
                              sx={{
                                backgroundColor: '#666',
                                '&:hover': { backgroundColor: '#444' }
                              }}
                            >
                              Selecionar imagem
                              <input
                                id="img-upload"
                                type="file"
                                name="ImgPath"
                                hidden
                                onChange={(e) => {
                                  const file = e.currentTarget.files?.[0];

                                  if (file) {
                                    setFieldValue("ImgName", file.name);
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                      setFieldValue("ImgPath", reader.result);
                                    };
                                    reader.readAsDataURL(file);
                                  } else {
                                    setFieldValue("ImgPath", null);
                                    setFieldValue("ImgName", null);
                                  }
                                }}
                              />
                            </MuiButton>

                            {values.ImgPath && (
                              <>
                                <p style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
                                  Arquivo Selecionado: <strong>{values.ImgName}</strong>
                                </p>
                                <img
                                  src={values.ImgPath || ''}
                                  alt="preview"
                                  style={{ maxWidth: "100px", marginTop: "10px" }}
                                />
                              </>
                            )}








                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Variacao'
                              as={InputSelect}
                              label='Produto com Variação'
                              type='text'
                              items={opcaoComboBox}
                              disabled={duploClick}
                              handleChange={(event: any) => {
                                const { value } = event.target;
                                setFieldValue('Variacao', value);
                              }}
                              error={
                                touched.Variacao && errors.Variacao
                                  ? errors.Variacao
                                  : ''
                              }
                              helperText={
                                touched.Variacao && errors.Variacao
                                  ? errors.Variacao
                                  : ''
                              }
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Usado'
                              as={InputSelect}
                              label='Produto Usado'
                              type='text'
                              items={opcaoComboBox}
                              disabled={duploClick}
                              handleChange={(event: any) => {
                                const { value } = event.target;
                                setFieldValue('Usado', value);
                              }}
                              error={Boolean(errors?.Usado)}
                              helperText={errors?.Usado}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='CodigoBarras'
                              as={TextField}
                              label='Código de Barras'
                              type='text'
                              error={Boolean(errors?.CodigoBarras)}
                              helperText={errors?.CodigoBarras}
                              disabled={duploClick}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Tipo'
                              as={TextField}
                              label='Tipo'
                              type='text'
                              error={Boolean(errors?.Tipo)}
                              helperText={errors?.Tipo}
                              disabled={duploClick}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Comissao'
                              as={TextField}
                              label='Percentual de Comissão'
                              type='text'
                              InputLabelProps={{ shrink: true }}
                              error={
                                touched.Comissao && errors.Comissao
                                  ? errors.Comissao
                                  : ''
                              }
                              helperText={
                                touched.Comissao && errors.Comissao
                                  ? errors.Comissao
                                  : ''
                              }
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Disponivel'
                              as={InputSelect}
                              label='Disponível para Venda'
                              type='text'
                              items={opcaoComboBox}
                              disabled={duploClick}
                              handleChange={(event: any) => {
                                const { value } = event.target;
                                setFieldValue('Disponivel', value);
                              }}
                              error={Boolean(errors?.Disponivel)}
                              helperText={errors?.Disponivel}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Grupo'
                              as={InputSelect}
                              className='col-span-2'
                              label='Grupo'
                              type='text'
                              items={itemsGrupo}
                              disabled={duploClick}
                              handleChange={(event: any) => {
                                const { value } = event.target;
                                setFieldValue('Grupo', value);
                              }}
                              error={
                                touched.Grupo && errors.Grupo
                              }
                              helperText={
                                touched.Grupo && errors.Grupo
                              }
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='UnidadeMedida'
                              as={InputSelect}
                              label='Unidade de Medida'
                              type='text'
                              items={opcaoComboUnidadeMedida}
                              disabled={duploClick}
                              handleChange={(event: any) => {
                                const { value } = event.target;
                                setFieldValue('UnidadeMedida', value);
                              }}
                              error={Boolean(errors?.UnidadeMedida)}
                              helperText={errors?.UnidadeMedida}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='PesoLiquido'
                              as={TextField}
                              label='Peso Líquido (Kg)'
                              type='text'
                              InputLabelProps={{ shrink: true }}
                              error={Boolean(errors?.PesoLiquido)}
                              helperText={errors?.PesoLiquido}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='PesoBruto'
                              as={TextField}
                              label='Peso Bruto (Kg)'
                              type='text'
                              InputLabelProps={{ shrink: true }}
                              error={Boolean(errors?.PesoBruto)}
                              helperText={errors?.PesoBruto}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='UltimaCompra'
                              as={TextField}
                              label='Data Última Compra'
                              InputLabelProps={{ shrink: true }}
                              type='date'
                              error={Boolean(errors?.UltimaCompra)}
                              helperText={errors?.UltimaCompra}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            {/* <Field
                          fullWidth
                          name='ValorVenda'
                          as={TextField}
                          label='Valor Venda'
                          type='text'
                          InputLabelProps={{ shrink: true }}
                          error={
                            touched.ValorVenda && errors.ValorVenda
                              ? errors.ValorVenda
                              : ''
                          }
                          helperText={
                            touched.ValorVenda && errors.ValorVenda
                              ? errors.ValorVenda
                              : ''
                          }
                        /> */}
                            <InputMoney
                              label={'Valor Venda'}
                              className={'col-span-2'}
                              name={'ValorVenda'}
                              size='medium'
                              value={values.ValorVenda}
                              handleChange={handleChange}
                              fullWidth
                              error={touched.ValorVenda && errors.ValorVenda}
                            //error={Boolean(touched.ValorVenda && errors.ValorVenda)} // agora é boolean
                            //helperText={touched.ValorVenda && errors.ValorVenda ? errors.ValorVenda : ''}
                            />

                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Fabricante'
                              as={TextField}
                              label='Fabricante'
                              type='text'
                              error={Boolean(errors?.Fabricante)}
                              helperText={errors?.Fabricante}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='PartNumber'
                              as={TextField}
                              label='PartNumber'
                              type='text'
                              error={Boolean(errors?.PartNumber)}
                              helperText={errors?.PartNumber}
                            />
                          </Grid>

                          <Grid item xs={12}>
                            <Field
                              name='Observacao'
                              label='Observação'
                              as={TextField}
                              type='text'
                              fullWidth
                              rows={5}
                              multiline
                              inputProps={{ maxLength: 300 }}
                              error={Boolean(errors?.Observacao)}
                              helperText={errors?.Observacao ? errors.Observacao : `${values.Observacao.length}/300`}
                            />
                          </Grid>

                        </Grid>
                      </TabPanel>

                      <TabPanel value='2'>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='GrupoTributario'
                              as={TextField}
                              label='Grupo Tributário Padrão'
                              type='text'
                              error={Boolean(errors?.GrupoTributario)}
                              helperText={errors?.GrupoTributario}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='ExTIPI'
                              as={TextField}
                              label='EX TIPI'
                              type='text'
                              error={Boolean(errors?.ExTIPI)}
                              helperText={errors?.ExTIPI}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='EnquadramentoIPI'
                              as={TextField}
                              label='Enquadramento Legal do IPI'
                              type='text'
                              error={Boolean(errors?.EnquadramentoIPI)}
                              helperText={errors?.EnquadramentoIPI}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='AliquotaIPI'
                              as={TextField}
                              label='Alíquota IPI'
                              type='text'
                              error={Boolean(errors?.AliquotaIPI)}
                              helperText={errors?.AliquotaIPI}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='AliquotaPIS'
                              as={TextField}
                              label='Alíquota PIS'
                              type='text'
                              error={Boolean(errors?.AliquotaPIS)}
                              helperText={errors?.AliquotaPIS}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='AliquotaCOFINS'
                              as={TextField}
                              label='Alíquota COFINS'
                              type='text'
                              error={Boolean(errors?.AliquotaCOFINS)}
                              helperText={errors?.AliquotaCOFINS}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='NCM'
                              as={TextField}
                              label={isServ ? 'NCM' : 'NCM *'}
                              type='text'
                              // maxLength 8 impede o dígito a mais antes de ele existir; o
                              // somenteDigitos abaixo cuida de texto colado com pontos.
                              inputProps={{ inputMode: 'numeric', maxLength: 8 }}
                              onChange={(e: any) =>
                                setFieldValue('NCM', somenteDigitos(e.target.value).slice(0, 8))
                              }
                              error={touched.NCM && errors.NCM ? errors.NCM : ''}
                              helperText={
                                touched.NCM && errors.NCM ? errors.NCM : ''
                              }
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='CEST'
                              as={TextField}
                              label='CEST'
                              type='text'
                              inputProps={{ inputMode: 'numeric' }}
                              onChange={(e: any) =>
                                setFieldValue('CEST', somenteDigitos(e.target.value))
                              }
                              error={Boolean(errors?.CEST)}
                              helperText={errors?.CEST}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='CodigoANVISA'
                              as={TextField}
                              label='Codigo de Produto ANVISA'
                              type='text'
                              error={Boolean(errors?.CodigoANVISA)}
                              helperText={errors?.CodigoANVISA}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='PrecoMaximo'
                              as={TextField}
                              label='Preço Máximo ao Consumidor'
                              type='text'
                              error={Boolean(errors?.PrecoMaximo)}
                              helperText={errors?.PrecoMaximo}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <InputMoney
                              label={'Valor Custo'}
                              className={'col-span-2'}
                              name={'ValorCusto'}
                              size='medium'
                              value={values.ValorCusto}
                              handleChange={handleChange}
                              fullWidth
                            />

                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='OrigemMercadoria'
                              as={TextField}
                              label='Origem Mercadoria'
                              type='text'
                              error={Boolean(errors?.OrigemMercadoria)}
                              helperText={errors?.OrigemMercadoria}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='FCI'
                              as={TextField}
                              label='FCI (Ficha de Conteúdo de Importação'
                              type='text'
                              error={Boolean(errors?.FCI)}
                              helperText={errors?.FCI}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='CodigoANP'
                              as={TextField}
                              label='Origem Mercadoria'
                              type='text'
                              error={Boolean(errors?.CodigoANP)}
                              helperText={errors?.CodigoANP}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='DescricaoANP'
                              as={TextField}
                              label='Descrição ANP'
                              type='text'
                              error={Boolean(errors?.DescricaoANP)}
                              helperText={errors?.DescricaoANP}
                            />
                          </Grid>
                        </Grid>

                        <Box
                          sx={{
                            mt: 3,
                            p: 2,
                            border: '1px solid #cecece',
                            borderRadius: 2,
                            backgroundColor: 'transparent',
                          }}
                        >
                          <Typography variant='subtitle1' sx={{ fontWeight: 600, mb: 2 }}>
                            Serviço - Tributos
                          </Typography>

                          <Grid container spacing={2}>
                            {/* Código Tributação Municipal (obrigatório) */}
                            <Grid item xs={4}>
                              <Field
                                size='small'
                                fullWidth
                                name='ServTribMunicipal'
                                as={TextField}
                                label={isServ ? 'Código Tributação Municipal *' : 'Código Tributação Municipal'}
                                type='text'
                                error={Boolean(errors?.ServTribMunicipal)}
                                helperText={errors?.ServTribMunicipal}
                              />
                            </Grid>

                            {/* Código Iss Específico */}
                            <Grid item xs={4}>
                              <Field
                                size='small'
                                fullWidth
                                name='ServIssEspecifico'
                                as={TextField}
                                label='Código Iss Específico'
                                type='text'
                                error={Boolean(errors?.ServIssEspecifico)}
                                helperText={errors?.ServIssEspecifico}
                              />
                            </Grid>

                            {/* Código Fiscal de Prestação */}
                            <Grid item xs={4}>
                              <Field
                                size='small'
                                fullWidth
                                name='ServCodigoFiscalPrestacao'
                                as={TextField}
                                label='Código Fiscal de Prestação'
                                type='text'
                                error={Boolean(errors?.ServCodigoFiscalPrestacao)}
                                helperText={errors?.ServCodigoFiscalPrestacao}
                              />
                            </Grid>

                            {/* ISS Tabela Padrão (obrigatório / Autocomplete) */}
                            <Grid item xs={12}>
                              <SelectAutoCompleteComponent
                                size='small'
                                label={isServ ? 'ISS Tabela Padrão *' : 'ISS Tabela Padrão'}
                                name='ServIss'
                                value={values.ServIssDescricao}
                                options={issOptions}
                                hasError={Boolean(errors?.ServIss)}
                                error={errors?.ServIss}
                                handleSearch={(value: string) => handleSearchIss(value)}
                                onSelectValue={(value: SelectAutoCompleteOptions) =>
                                  handleSelectIss(value, setFieldValue)
                                }
                              />
                            </Grid>

                            {/* NBS (obrigatório / Autocomplete) */}
                            <Grid item xs={12}>
                              <SelectAutoCompleteComponent
                                size='small'
                                label={isServ ? 'NBS *' : 'NBS'}
                                name='ServNbs'
                                value={values.ServNbsDescricao}
                                options={nbsOptions}
                                hasError={Boolean(errors?.ServNbs)}
                                error={errors?.ServNbs}
                                handleSearch={(value: string) => handleSearchNbs(value)}
                                onSelectValue={(value: SelectAutoCompleteOptions) =>
                                  handleSelectNbs(value, setFieldValue)
                                }
                              />
                            </Grid>

                            {/* Tipo de Operação (Autocomplete) */}
                            <Grid item xs={12}>
                              <SelectAutoCompleteComponent
                                size='small'
                                label={isServ ? 'Tipo de Operação *' : 'Tipo de Operação'}
                                name='ServTipoOperacao'
                                value={values.ServTipoOperacaoDescricao}
                                options={operacaoOptions}
                                handleSearch={(value: string) => handleSearchOperacao(value)}
                                onSelectValue={(value: SelectAutoCompleteOptions) =>
                                  handleSelectOperacao(value, setFieldValue)
                                }
                              />
                            </Grid>

                            {/* Discriminação (obrigatório) */}
                            <Grid item xs={12}>
                              <Field
                                size='small'
                                fullWidth
                                multiline
                                minRows={2}
                                maxRows={5}
                                name='ServDiscriminacao'
                                as={TextField}
                                label={isServ ? 'Discriminação *' : 'Discriminação'}
                                error={Boolean(errors?.ServDiscriminacao)}
                                helperText={errors?.ServDiscriminacao}
                                sx={{
                                  // Neutraliza o height fixo (48px) do tema p/ o campo crescer com as linhas
                                  '& .MuiOutlinedInput-root': { height: 'auto' },
                                  // Alinha a fonte à dos demais campos
                                  '& .MuiInputBase-input': { fontSize: '1rem' },
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Box>
                      </TabPanel>

                      <TabPanel value='3'>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='ControlaLote'
                              as={TextField}
                              label='Controla Lote'
                              type='text'
                              error={Boolean(errors?.ControlaLote)}
                              helperText={errors?.ControlaLote}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Armazem'
                              as={TextField}
                              label='Armazem'
                              type='text'
                              error={Boolean(errors?.Armazem)}
                              helperText={errors?.Armazem}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Saldo'
                              as={TextField}
                              label='Saldo'
                              type='text'
                              error={Boolean(errors?.Saldo)}
                              helperText={errors?.Saldo}
                            />
                          </Grid>

                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='SaldoMinimo'
                              as={TextField}
                              label='Saldo Minimo'
                              type='text'
                              error={Boolean(errors?.SaldoMinimo)}
                              helperText={errors?.SaldoMinimo}
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <Field
                              size='small'
                              fullWidth
                              name='Lote'
                              as={TextField}
                              label='Lote'
                              type='text'
                              error={Boolean(errors?.Lote)}
                              helperText={errors?.Lote}
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            paddingTop: 5, // Adiciona um espaçamento no topo, afastando o conteúdo da borda
                          }}
                        >
                          <ComponentTable
                            columns={tableColumns}
                            rows={tableRows}
                          />
                        </Grid>
                      </TabPanel>

                      <TabPanel value='4'>
                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <SelectAutoCompleteComponent
                              size='small'
                              label={'Produto do Kit'}
                              value={activeProdutoSelected?.prod_produto_kit ?? ''}
                              className={'col-span-6'}
                              name={'search'}
                              options={produtoOptions}
                              handleSearch={(value: string) =>
                                handleSearchProduto(value, 'ProdutoKit')
                              }
                              onSelectValue={handleAutoCompleteSelectedProduto}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <Field
                              fullWidth
                              size='small'
                              name='QuantidadeKit'
                              as={TextField}
                              label='Quantidade'
                              type='text'
                              error={Boolean(errors?.QuantidadeKit)}
                              helperText={errors?.QuantidadeKit}
                            />
                          </Grid>

                          <Grid item xs={2}>
                            <Button
                              //type='submit'
                              size='large'
                              variant='contained'
                              onClick={() => handleKitSubmit(values, setFieldValue)}
                              color='success'
                              startIcon={<Icon.Save />}
                              disabled={duploClick}
                            >
                              Adicionar
                            </Button>
                          </Grid>
                        </Grid>
                        <Grid
                          container
                          spacing={2}
                          sx={{
                            paddingTop: 5, // Adiciona um espaçamento no topo, afastando o conteúdo da borda
                          }}
                        >
                          <ComponentTable
                            columns={tableColumnsKit}
                            rows={tableRowsKit}
                          />
                        </Grid>
                      </TabPanel>
                    </fieldset>
                  </TabContext>
                </Box>
              </Form>
            )
          }
          }
        </Formik>
      </div>
    </Loader>
  );
}
